export default "<mat-card class=\"sub-card\">\r\n    <ng-content></ng-content>\r\n</mat-card>\r\n"